import React from "react";

function Maincontent() {
  return (
    <div>
      <h1>Maincontent</h1>
      <p>
        Lorem ipsum, dolor sit amet consectetur adipisicing elit. Voluptates
        magnam, quaerat aspernatur ut molestias error possimus vero illo est
        alias nesciunt cumque recusandae quisquam, quasi ea nam enim ex nulla.
      </p>
    </div>
  );
}

export default Maincontent;
